import { IProject } from '../../models/IProject';
import * as moment from 'moment';

const DATA_API_HOST = process.env.DATA_API_HOST;

function getDownloadScriptsAsZipLink(project: IProject, environment: string) {
    const { protocol } = window.location;
    const tagId = project[`${environment}TagId`];
    const scriptDownloadLink = `${protocol}//${DATA_API_HOST}${project.scriptDownloadLink + tagId}`;

    return scriptDownloadLink;
}

function downloadScriptsHelper(project, environment) {
    return new Promise<void>((resolve, reject) => {
        if (window.fetch) {
            const reqParam = {
                method: 'GET',
                mode: 'cors' as RequestMode
            };
            window.fetch(getDownloadScriptsAsZipLink(project, environment), reqParam)
                .then(response => {
                    response.blob().then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = `${project.name}_${moment().format('YYYY-MM-DD_HH-mm-ss')}.zip`;
                        try {
                            a.download = response.headers
                                .get('content-disposition')
                                .split('; ')[1]
                                .split('"')[1];
                        } catch (error) {

                        }

                        a.click();
                        resolve();
                    });
                }, () => {
                    reject();
                });
        } else {
            const link = document.createElement("a");
            link.setAttribute("href", getDownloadScriptsAsZipLink(project, environment));
            document.body.appendChild(link);
            link.click();
            resolve();
        }
    });
}

export default downloadScriptsHelper;
